/**
 * KeyAssignment model translations
 *
 * Translation keys follow the pattern: models.key-assignment.{category}.{key}
 * Categories: fields, blocks, badges, filters
 */
export default {
  en: {
    singular: "Key Assignment",
    plural: "Key Assignments",

    blocks: {
      key_info: "Key Details",
      assignment_info: "Assignment Info",
      unassignment_info: "Unassignment Info",
      notes: "Notes",
    },

    fields: {
      key_id: "Key",
      user_id: "Employee",
      assigned_by_user_id: "Assigned By",
      unassigned_by_user_id: "Unassigned By",
      assigned_at: "Assigned At",
      unassigned_at: "Unassigned At",
      notes: "Notes",
      is_current: "Status",
      key: {
        code: "Key Code",
        name: "Key Name",
        client: {
          name: "Client",
        },
      },
      user: {
        display_name: "Employee",
      },
      assignedBy: {
        display_name: "Assigned By",
      },
      unassignedBy: {
        display_name: "Unassigned By",
      },
    },

    badges: {
      Current: "Current",
      Historical: "Historical",
    },

    filters: {
      key_id: "Key",
      user_id: "Employee",
      assigned_by_user_id: "Assigned By",
      unassigned_at: "Unassigned",
    },
  },

  fr: {
    singular: "Attribution de clé",
    plural: "Attributions de clés",

    blocks: {
      key_info: "Détails de la clé",
      assignment_info: "Infos d'attribution",
      unassignment_info: "Infos de désassignation",
      notes: "Notes",
    },

    fields: {
      key_id: "Clé",
      user_id: "Employé",
      assigned_by_user_id: "Attribué par",
      unassigned_by_user_id: "Désassigné par",
      assigned_at: "Attribué le",
      unassigned_at: "Désassigné le",
      notes: "Notes",
      is_current: "Statut",
      key: {
        code: "Code de clé",
        name: "Nom de clé",
        client: {
          name: "Client",
        },
      },
      user: {
        display_name: "Employé",
      },
      assignedBy: {
        display_name: "Attribué par",
      },
      unassignedBy: {
        display_name: "Désassigné par",
      },
    },

    badges: {
      Current: "Actuel",
      Historical: "Historique",
    },

    filters: {
      key_id: "Clé",
      user_id: "Employé",
      assigned_by_user_id: "Attribué par",
      unassigned_at: "Désassigné",
    },
  },
};
